import { render } from "./TimePunchPage.vue?vue&type=template&id=004225e6&scoped=true"
import script from "./TimePunchPage.vue?vue&type=script&lang=js"
export * from "./TimePunchPage.vue?vue&type=script&lang=js"

import "./TimePunchPage.vue?vue&type=style&index=0&id=004225e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004225e6"]])

export default __exports__